import { useTranslation } from 'react-i18next'

import { cn } from '@/lib/utils'
import { setUiLanguage, UI_LANGUAGES, resolveUiLanguage } from '@/i18n'
import type { UiLanguage } from '@/i18n'

const NATIVE_LABELS: Record<UiLanguage, string> = {
  en: 'English',
  es: 'Español',
  fr: 'Français',
  'pt-BR': 'Português',
}

interface UiLanguageSwitcherProps {
  className?: string
}

export function UiLanguageSwitcher({ className }: UiLanguageSwitcherProps) {
  const { t, i18n } = useTranslation('common')
  const current: UiLanguage = resolveUiLanguage(i18n.language)

  return (
    <label className={cn('inline-flex items-center gap-2 text-sm text-muted-foreground', className)}>
      <span className="sr-only">{t('language')}</span>
      <select
        data-testid="ui-language-switcher"
        value={current}
        onChange={(event) => {
          void setUiLanguage(event.target.value as UiLanguage)
        }}
        className="cursor-pointer rounded-md border border-border bg-background px-2 py-1 text-sm text-foreground"
      >
        {UI_LANGUAGES.map((code) => (
          <option key={code} value={code}>
            {NATIVE_LABELS[code]}
          </option>
        ))}
      </select>
    </label>
  )
}
